import type { DmsScheduleAccountsI } from 'declarations/interfaces/dmsScheduleAccounts';
import type { DmsScheduleAutomationDto } from 'declarations/interfaces/DmsScheduleAutomationDto';

import { get, post } from './api';

export const getDmsScheduleAccounts = async (
  roofTopId: string | undefined
): Promise<DmsScheduleAccountsI[]> => {
  const response = await get<DmsScheduleAccountsI[]>(
    `/dms-schedule-accounts/by-rooftop-id/${roofTopId}`
  );

  return response.data;
};

export const getDmsScheduleAutomationStatus = async (
  roofTopId: string
): Promise<DmsScheduleAutomationDto> => {
  const response = await get<DmsScheduleAutomationDto>(
    `/dms-schedule-integration/automation-status/${roofTopId}`
  );

  return response.data;
};

export const createDmsScheduleIntegrationRequest = async (roofTopId: string): Promise<void> => {
  const response = await post<void>(`/dms-schedule-integration/integration-request/${roofTopId}`);

  return response.data;
};
